import {
  FETCH_HYPO_CHART_REQUEST,
  FETCH_HYPO_CHART_SUCCESS,
  FETCH_HYPO_CHART_FAILURE
} from '../../actions/action-types';

const initialState = {
  chartLoading: {},
  hypoChartData: {},
  error: ''
};

const chartReducer = (state = initialState, action) => {
  // The reducer normally looks at the action type field to decide what happens
  switch (action.type) {
    case FETCH_HYPO_CHART_REQUEST: {
      const tempChartLoading = { ...state.chartLoading };
      tempChartLoading[action.xid] = true;

      return {
        ...state,
        chartLoading: tempChartLoading
      };
    }
    case FETCH_HYPO_CHART_SUCCESS: {
      const tempFundData = { ...state.hypoChartData };
      tempFundData[action.xid] = action.payload;
      const tempChartLoading = { ...state.chartLoading };
      tempChartLoading[action.xid] = false;

      return {
        ...state,
        chartLoading: tempChartLoading,
        hypoChartData: tempFundData,
        error: ''
      };
    }
    case FETCH_HYPO_CHART_FAILURE: {
      const tempChartLoading = { ...state.chartLoading };
      tempChartLoading[action.xid] = false;

      return {
        ...state,
        chartLoading: tempChartLoading,
        error: action.payload
      };
    }
    default:
      return state;
  }
};

export default chartReducer;
